import Dashboard from '../../components/Dashboard'
import ProductoAdd from '../../components/Productos/Add/Add'
import useFetchProduct from '../../hooks/useFetchProduct'

const ProductosIdPage = () => {

  const {producto, descargable} = useFetchProduct()

  return (
    <Dashboard>
      <ProductoAdd producto={producto} key={producto?.descripcion} descargable={descargable} />
    </Dashboard>
  )
}

export default ProductosIdPage